export const PLUGIN_TYPE_ENUM = {
  PLUGIN: 'PLUGIN',
  ORDER: 'ORDER',
  BUTTON: 'BUTTON',
} as const;
export type PLUGIN_TYPE_ENUM =
  (typeof PLUGIN_TYPE_ENUM)[keyof typeof PLUGIN_TYPE_ENUM];
export const PLUGIN_TYPE = {
  PAYMENT: 'PAYMENT',
  PLUGIN: 'PLUGIN',
  ORDER: 'ORDER',
  BUTTON: 'BUTTON',
};
